import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import RDFIcon from '../../images/target-date.svg';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const RDFCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      icon={RDFIcon}
      title="Get a recommendation"
      spacedTitle
      subtitle={
        <div>
          Get a recommendation for a <span>T. Rowe Price®</span> Retirement
          Fund, one set of our target date funds, based on your date of birth
        </div>
      }
      buttonText="Use My Date of Birth"
      buttonFunction={next('rdf')}
      buttonID={generateGeneralTestID('Card', 'RecommendFundButton')}
      cardID={generateGeneralTestID('Card', 'RecommendFundCard')}
    />
  );
};

export default RDFCard;
